import { Text } from "@mantine/core"
import { PlanLayoutAttachmentList } from "./PlanLayoutAttachmentList"
import { useTranslation } from "react-i18next"
import { useQueryGet } from "@/typed-client/hooks/use-query-get"

interface Props {
  planId: number
}

export function PublishedPlanList({ planId }: Props) {
  const { data: publishedPlans } = useQueryGet(
    "/api/planLayout/attachments/GetPlanLayoutAttachments",
    {
      planLayoutIds: planId ? [planId] : [],
      onlyPublishedOnDashboard: false,
      includeInactive: true,
    },
    { enabled: planId !== undefined && planId !== null }
  )

  const { t } = useTranslation("app_server")

  return (
    <>
      {!publishedPlans || publishedPlans.length === 0 ? (
        <Text>{t("NoPlansHaveBeenPublished")}</Text>
      ) : (
        <PlanLayoutAttachmentList
          withoutGroupHeader
          attachments={publishedPlans}
        />
      )}
    </>
  )
}
